import React from 'react'

const Read = () => {
  return (
    <div>This is the "read" page</div>
  )
}

export default Read